import { BaseModel, convertToArrayModels, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import LandingFeedbackField from './LandingFeedbackField'

export default class LandingFeedbackBlock extends BaseModel {
  static override constructorName = 'LandingFeedbackBlock'

  readonly name = 'feedback_block'

  title: string = ''
  text: string = ''
  fields: LandingFeedbackField[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['fields'])

      this.fields = convertToArrayModels(data.fields, LandingFeedbackField)
    }
  }
}
